import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTooltip,{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn,_vm._g({staticStyle:{"width":"100%"},attrs:{"tile":_vm.mini,"icon":_vm.mini,"elevation":"0","color":"primary","loading":_vm.loading,"disabled":_vm.loading,"link":"","to":_vm.route}},on),[_c(VIcon,{attrs:{"left":!_vm.mini,"small":!_vm.mini}},[_vm._v("mdi-microphone")]),(!_vm.mini)?_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t("upsess.rectip")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }